import React from 'react';
import { Link, withRouter } from 'react-router-dom';

const WHATSAPP = 'https://wa.me/5217712438160?text=' + encodeURIComponent('Hola, ¿me podrías brindar información del servicio de internet?');

const DOCS_LEGAL = 'https://www.reditmex.com/documentacion/legal';

const COLUMNAS = [
    {
        titulo: 'Servicios',
        links: [
            { href: '/#planesInternet', texto: 'Planes' },
            { to: '/cobertura', texto: 'Cobertura' },
            { to: '/internet/faq', texto: 'Preguntas frecuentes' },
            { to: '/contacto', texto: 'Contratar' },
        ],
    },
    {
        titulo: 'Compañía',
        links: [
            { to: '/nosotros', texto: 'Nosotros' },
            { to: '/contacto', texto: 'Contacto' },
            { to: '/podcasts', texto: 'Podcasts' },
        ],
    },
    {
        titulo: 'Documentación',
        links: [
            { href: `${DOCS_LEGAL}/carta-de-derechos-mínimos-de-los-usuarios/pdf/v3`, texto: 'Carta de Derechos Mínimos', externo: true },
            { href: `${DOCS_LEGAL}/codigo-de-prácticas-comerciales/pdf/v3`, texto: 'Código de Prácticas Comerciales', externo: true },
            { href: `${DOCS_LEGAL}/titulo-de-concesion/pdf/v3`, texto: 'Título de la Concesión', externo: true },
            { href: `${DOCS_LEGAL}/contrato-de-adhesion/pdf/v3`, texto: 'Registro de Contrato de Adhesión de Telecomunicaciones', externo: true },
            { to: '/documentacion', texto: 'Otros documentos' },
        ],
    },
];

const REDES = [
    { href: 'https://www.facebook.com/itmexoficial', icono: 'fab fa-facebook-f', nombre: 'Facebook' },
    { href: 'https://www.instagram.com/reditmex/', icono: 'fab fa-instagram', nombre: 'Instagram' },
    { href: 'https://www.youtube.com/channel/UC6Sirelw0bYpaT4VktsK19A', icono: 'fab fa-youtube', nombre: 'YouTube' },
    { href: 'https://open.spotify.com/show/56dQAu73j4a0QaLRO44oa7', icono: 'fab fa-spotify', nombre: 'Spotify' },
    { href: 'https://podcasts.apple.com/mx/podcast/internet-en-pandemia/id1552637394', icono: 'fas fa-podcast', nombre: 'Apple Podcasts' },
    { href: WHATSAPP, icono: 'fab fa-whatsapp', nombre: 'WhatsApp' },
];

const FooterLink = ({ link }) => link.to
    ? <Link to={link.to}>{link.texto}</Link>
    : <a href={link.href} {...(link.externo ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>{link.texto}</a>;

const Footer = () => (
    <footer className="footerItmex">
        <div className="footerItmex-card">
            {/* Ilustración anclada abajo: la antena queda entre el CTA y el panel de vidrio */}
            <img className="footerItmex-bg" src="/assets/img/backgrounds/ixmiquilpan-footer.jpg" alt="" loading="lazy" />
            <div className="footerItmex-cta">
                <h2 className="footerItmex-cta-titulo">Conéctate con Itmex</h2>
                <p className="footerItmex-cta-texto">Revisa la cobertura en tu comunidad y elige el plan para tu hogar o negocio.</p>
                <div className="heroItmex-actions">
                    <Link className="heroItmex-cta" to="/contacto">
                        Contratar
                        <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                    </Link>
                    <a className="heroItmex-cta-secondary" href={WHATSAPP} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-whatsapp mr-2"></i> WhatsApp
                    </a>
                </div>
            </div>

            <div className="footerItmex-glass">
                <div className="footerItmex-top">
                    <Link to="/" aria-label="Red Itmex - Inicio">
                        <img className="footerItmex-logo" src="/assets/img/logos/LOGOMINNEGRO.png" alt="Red Itmex" />
                    </Link>
                    <span className="footerItmex-copy">© {new Date().getFullYear()} Red Itmex</span>
                </div>

                <div className="footerItmex-columnas">
                    <div className="footerItmex-columna">
                        <span className="footerItmex-columna-titulo">Contacto</span>
                        <ul className="footerItmex-contacto">
                            <li><i className="fas fa-location-arrow"></i>Av. 5 de Mayo No.1, Colonia Centro, Ixmiquilpan Hidalgo, C.P. 42300</li>
                            <li><i className="fas fa-phone-alt"></i><a href="tel:+527712438160">+52 771 243 81 60</a></li>
                            <li><i className="fas fa-envelope"></i><a href="mailto:asistencia@reditmex.com">asistencia@reditmex.com</a></li>
                            <li><i className="fas fa-clock"></i>Horario de Atención: Lunes a Domingo de 9:00 a 18:00</li>
                        </ul>
                    </div>
                    {COLUMNAS.map(columna => (
                        <div className="footerItmex-columna" key={columna.titulo}>
                            <span className="footerItmex-columna-titulo">{columna.titulo}</span>
                            <ul>
                                {columna.links.map(link => <li key={link.texto}><FooterLink link={link} /></li>)}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="footerItmex-bottom">
                    <div className="footerItmex-redes">
                        {REDES.map(red => (
                            <a key={red.nombre} href={red.href} target="_blank" rel="noopener noreferrer" aria-label={red.nombre}>
                                <i className={red.icono}></i>
                            </a>
                        ))}
                    </div>
                    <div className="footerItmex-legal-links">
                        <Link to="/privacidad">Política de Privacidad</Link>
                        <Link to="/documentacion">Documentación</Link>
                        <span><img src="/assets/vendor/flag-icon-css/flags/4x3/mx.svg" alt="" /> México</span>
                    </div>
                </div>

                <div className="footerItmex-notas">
                    <p>© Red Itmex. {new Date().getFullYear()} Todos los derechos reservados. Powered by <a href="https://zerep.mx" target="_blank" rel="noopener noreferrer"><b>Zerep</b></a></p>
                    <p>Cuando visitas o interactuas con nuestros sitios, servicios o herramientas, nosotros o nuestros proveedores de servicios autorizados podrían usar cookies para almacer información que ayude a brindarte una mejor, más rapida y más segura, experiencia y con fines de mercadeo.</p>
                    <p>Facebook, WhatsApp, Youtube, Instagram, Spotify y Podcasts, son marcas registradas de sus respectivos propietarios. Itmex no está afiliado a dichas empresas.</p>
                </div>
            </div>
        </div>
    </footer>
)
export default withRouter(Footer);
